<template>
  <b-modal ref="my-modal-divvy-admin" title="System Message">
    <p>{{ getModalMessage }}</p>
  </b-modal>
</template>

<script>
export default {
  name: "divvyAdminModal",

  computed: {
    getModalMessage() {
      return this.$store.getters["divvySystemMessage/getModalMessage"];
    },
  },
  watch: {
    getModalMessage(getModalMessage) {
      if (getModalMessage) {
        this.$refs["my-modal-divvy-admin"].show();
      } else if (!getModalMessage) {
        this.$refs["my-modal-divvy-admin"].hide();
      }
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      this.$store.dispatch("divvySystemMessage/setModalMessage", {
        message: "",
      });
    });
  },
  methods: {},
};
</script>

<style>
.modal-header {
  padding: 1rem 1rem !important;
}
.modal-body {
  padding: 0rem 0rem 0 2rem !important;
}
</style>
